module.exports = __webpack_public_path__ + "static/media/22ESCWA19.6a3a36b2.jpg";